import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ui from 'redux-ui';
import { connect } from 'react-redux';
import UserFilters from 'components/Filters/UserFilters';
import PageActionBar from 'components/PageActionBar';
import EstimatorList from './estimatorList';
import EstimatorDetails from './estimatorDetails';
import EstimatorNew from './estimatorNew';
import EstimatorEdit from './estimatorEdit';
import contentAreaStyles from 'styles/contentArea';
import { getRole, getEstimatorFilters } from '../../../../reducers';
import { navigate, setEstimatorFilters, resetEstimatorFilters } from 'actionCreators';

const searchText = 'Search for an estimator';

class Estimators extends Component {
  constructor(props) {
    super(props);
    this.addAction = this.addAction.bind(this);
    this.state = { showFilterDrawer: false };
    this.toggleFilterDrawer = () => (this.setState({
      showFilterDrawer: !this.state.showFilterDrawer }));
    this.handleFilterChange = filters => (this.props.setEstimatorFilters(filters));
    this.isIndexRoute = () => (this.props.location.pathname === this.props.route.path);
  }

  onSearch = (e, value) => {
    e.preventDefault();
    const filters = { ...this.props.filters };
    filters.query = value;
    this.handleFilterChange(filters);
  }

  addAction = () => (this.props.navigate('/estimators/new'));

  render = () => {
    const { children, role, filters } = this.props;
    return (<div>
      <PageActionBar
        hidesAddOnMobile
        resource="estimator"
        role={role}
        addAction={this.addAction}
        showFiltersBtn={this.isIndexRoute()}
        title="Estimator Management"
        searchText={`${searchText}...`}
        toggleFilters={this.toggleFilterDrawer}
        onSearch={this.onSearch}
        path={this.props.location.pathname}
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        {children}
        <UserFilters
          active={this.state.showFilterDrawer}
          onOverlayClick={this.toggleFilterDrawer}
          handleFilterChange={this.handleFilterChange}
          filters={filters}
          title="Estimators"
          reset={this.props.resetEstimatorFilters}
          role={this.props.role}
          resource="estimator"
        />
      </div>
    </div>);
  }
}

Estimators.propTypes = {
  setEstimatorFilters: PropTypes.func.isRequired,
  navigate: PropTypes.func,
  location: PropTypes.object,
  route: PropTypes.object,
  role: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  filters: PropTypes.object,
  resetEstimatorFilters: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({ role: getRole(state), filters: getEstimatorFilters(state) });

export default ui({
  key: 'estimators', state: { successMessage: '', activeTab: 0 },
})(connect(mapStateToProps, {
  navigate, setEstimatorFilters, resetEstimatorFilters,
})(Estimators));

export { EstimatorList, EstimatorDetails, EstimatorNew, EstimatorEdit };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/index.jsx